import React from 'react';
import PropTypes from 'prop-types';
import { Select as RRS } from 'react-responsive-select';
import './Select.css';
import { SelectContainer, SelectIcon } from './Select.style';

/**
 * This component is a wrapper around a responsive Select component.
 * The `options` and `selected` props for the selectable values must have `value` and `text` fields,
 * which are used to identify them uniquely and for textual representation respectively.
 *
 * The `onChange` listener is called every time an option has been selected. It receives the `{value, text, name}`
 * object as an argument, where `value` and `text` represent the currently selected option and `name` is the
 * `name` prop that was passed as a prop to identify this Select component.
 *
 * Use the `valid` flag to show the Select in an error state.
 *
 */

const renderCaretIcon = () => {
  return <SelectIcon key="select-caret-icon" icon="expand-bottom-point" />;
};

const Select = ({
  valid = true,
  name,
  options,
  onChange,
  disabled = false,
  selected
}) => {
  return (
    <SelectContainer $hasError={!valid}>
      <RRS
        key={`${name}.${options.length}.${selected.text}`}
        name={name}
        options={options}
        onSubmit={() => {}}
        selectedValue={selected.value}
        onChange={onChange}
        caretIcon={renderCaretIcon()}
        disabled={disabled}
      />
    </SelectContainer>
  );
};
export default Select;

Select.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      text: PropTypes.string
    })
  ).isRequired,

  name: PropTypes.string.isRequired,
  valid: PropTypes.bool,
  disabled: PropTypes.bool
};
